(() => {
  const disclosures = [...document.querySelectorAll('.ve-device-disclosure')];
  document.addEventListener('click', event => {
    disclosures.forEach(details => { if (details.open && !details.contains(event.target)) details.open = false; });
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    disclosures.forEach(details => {
      if (!details.open) return;
      details.open = false;
      const target = matchMedia('(max-width: 900px)').matches ? document.querySelector('[data-menu-button]') : details.querySelector('summary');
      target?.focus();
    });
  });
})();
